import { DanceStyleInterface } from '../dance-style.interface';
import { DpsPostingInterface } from './dps-posting.interface';

export class DpsPostingsToDanceStylesInterface {
  dancePartnerSearchPosting?: DpsPostingInterface;
  danceStyle?: DanceStyleInterface;
  experienceFrom?: number;
  experienceTo?: number;
}
